import { useState } from 'react';
import { loginUser } from '../api/auth/auth';
import { useNavigate } from 'react-router-dom';
import '../../src/assets/styles/login.scss';
import Google from './Google';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e: any) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      await loginUser(email, password);
      navigate('/admin/welcome', { replace: true });
    } catch (e) {
      alert('Błędne dane logowania');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="login-wrap">
      <section className="login-card">
        <header className="login-header">
          <div className="login-logo" aria-hidden><img src="/splash-icon.png" alt="Logo" width={52}/></div>
          <h1>Logowanie</h1>
          <p>Zaloguj się, aby przejść do panelu administracyjnego.</p>
        </header>

        <form onSubmit={handleLogin} className="login-form" noValidate>
          <label className="login-label">
            Email
            <input
              className="login-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="np. jan.kowalski@example.com"
              autoComplete="email"
              required
            />
          </label>

          <label className="login-label">
            Hasło
            <input
              className="login-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete="current-password"
              required
            />
          </label>

          <button className="login-button" type="submit" disabled={submitting}>
            {submitting ? 'Logowanie…' : 'Zaloguj'}
          </button>
        </form>

        {/* ⬇️ Separator i Google login pod przyciskiem „Zaloguj” */}
        <div className="login-separator" aria-hidden>
          <span className="line" />
          <span className="text">lub</span>
          <span className="line" />
        </div>

        <div className="login-oauth">
          <Google />
        </div>

        <footer className="login-footer">
          <small>© {new Date().getFullYear()} PolyLect</small>
        </footer>
      </section>
    </main>
  );
}
